import { Component, Input } from '@angular/core';
import { RangePickerFieldComponent } from '../range-picker/range-picker.component';
import {
    FormGroup,
    FormsModule,
    ReactiveFormsModule
} from '@angular/forms';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { FieldBase } from '@nagel-types';

@Component({
    selector: 'lib-date-range-picker',
    imports: [
        RangePickerFieldComponent,
        ReactiveFormsModule,
        FormsModule,
        MatInputModule,
        MatNativeDateModule,
        FormsModule
    ],
    templateUrl: './date-range-picker.component.html',
    styleUrl: './date-range-picker.component.scss'
})
export class DateRangePickerComponent
    extends BaseFieldComponent
{
  @Input() override field!: FieldBase<unknown>;
  @Input() override form!: FormGroup;

  @Input() key: string = '';
  @Input() className: string = '';
  @Input() onChange: (event: any) => void = () => {};

  ngOnInit() {
      this.key = this.field?.key ?? this.key;
      this.className = this.field?.className ?? this.className;
      this.onChange = this.field?.onChange ?? this.onChange;
  }
}